import { FC, useRef, useEffect, HTMLAttributes, useContext } from 'react'
import { PreventScrollContext } from 'components/features/pfm/PreventScroll/PreventScrollContextProvider'

export type PreventScrollOwnProps =
  & HTMLAttributes<HTMLDivElement>
  & {
    allowScroll?: boolean // Allows override without triggering re-render of children
    innerRef?: (el: HTMLElement | null) => void
  }

export const PreventScroll: FC<PreventScrollOwnProps> = (props) => {
  const { children, allowScroll, innerRef, ...restProps } = props

  const ref = useRef<HTMLDivElement>(null)

  const { onScrollPreventionChange } = useContext(PreventScrollContext)

  useEffect(() => {
    onScrollPreventionChange()

    return () => {
      onScrollPreventionChange()
    }
  }, [allowScroll, onScrollPreventionChange])

  useEffect(() => {
    if (!innerRef) {
      return
    }
    innerRef(ref.current)
  }, [innerRef])

  return (
    <div
      ref={ ref }
      data-scroll={ allowScroll ? 'allow' : 'prevent-others' }
      { ...restProps }
    >
      { children }
    </div>
  )
}
